import { Directive, Self, OnInit, OnDestroy, Optional } from "@angular/core";
import { NgControl } from '@angular/forms';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { FormChangesService } from './form-changes.service';

@Directive({
  selector: '[formControlName],[formControl]'
})
export class FormChangesDirective implements OnInit, OnDestroy {

  constructor(
    @Self() private ngControl: NgControl,
    @Optional() private formChanges: FormChangesService) { }

  ngOnInit(): void {
    if (this.formChanges != null) {
      this.formChanges.stateChanges
        .pipe(untilDestroyed(this))
        .subscribe(p => {
          if (p.type === 'touched') {
            this.ngControl.control.markAsTouched();
            this.ngControl.control.updateValueAndValidity();
          }
        });
    }
  }

  ngOnDestroy(): void { }
}
